




































import Vue from "vue";

interface Props {
  layoutStandard: boolean;
  layoutFlex: boolean;
}

/**
 * >>> Few opinionated card layout variation:
 *  ----- Layout standard -----
 *  - the footer always has the border-top separator
 *  - the footer slots and default slot content direct children
 *    will have a horizontal padding to ensure content alignment. Default slot
 *    also has a vertical padding, assuming there is a single container in the
 *    default slot
 * - font color is "--color-dark"
 * - header slot padding is untouched as there are many possible headers which
 *   needs a zero padding.
 *
 *  ------ Layout flex --------
 *  - header and footer are always visible
 *  - the main content will grow and is scrollable if necessary
 *
 * >>> Other comments:
 *  ----- Footer buttons ------
 * Footer buttons are always contained in a JzButtonGroup. To keep the JzCard
 * functional, local components cannot be used. As The JzButtonGroup is only
 * bringing the `jz-button-group` and a set of CSS classes, it is for the moment
 * reasonable to re-use the CSS classes to handle footer buttons
 */
export default Vue.extend<Props>({
  name: "JzCard",
  functional: true,
  props: {
    layoutStandard: { type: Boolean, default: false },
    layoutFlex: { type: Boolean, default: false }
  }
});
